import { render } from "./IndexTopbar.vue?vue&type=template&id=1ddbd7ba&scoped=true"
import script from "./IndexTopbar.vue?vue&type=script&lang=js"
export * from "./IndexTopbar.vue?vue&type=script&lang=js"

import "./IndexTopbar.vue?vue&type=style&index=0&id=1ddbd7ba&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Anderson\\Documents\\GitHub\\px40-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ddbd7ba"]])

export default __exports__